import type { PreparationInput, PreparationResult } from '../types';
import { generatePreparation } from './preparationEngine';

export interface PreparationProvider {
  generate: (input: PreparationInput) => Promise<PreparationResult>;
}

class LocalPreparationProvider implements PreparationProvider {
  async generate(input: PreparationInput): Promise<PreparationResult> {
    return generatePreparation(input);
  }
}

// Futuro: ApiPreparationProvider com chamada para IA real.
const provider: PreparationProvider = new LocalPreparationProvider();

export const preparationService = {
  generate: (input: PreparationInput) => provider.generate(input)
};
